<template>
    <div class="animated fadeIn approvalTemplate masterPage">
        <div class="inner bg-gray-f9f">
            <div class="mainContent">
                <div class="left dataContent" v-bind:class="{'run-loading': template.loading}">
                    <div class="header">
                        <h3>Template</h3>
                        <div class="control">
                            <b-button @click="modals.deleteTemplate.open = true" v-if="this.$checkRole(this.$accessModule.approval_template, 'delete')">
                                <div class="tooltip">Delete</div>
                                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                </svg>
                            </b-button>
                            <b-button @click="openCreatetemplate" v-if="this.$checkRole(this.$accessModule.approval_template, 'create') == true">
                                <div class="tooltip">Create</div>
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                </svg>
                            </b-button>
                            <b-button @click="openUpdatetemplate" v-if="this.$checkRole(this.$accessModule.approval_template, 'update')">
                                <div class="tooltip">Edit</div>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.708 5.63151C21.098 6.02151 21.098 6.65151 20.708 7.04151L18.878 8.87151L15.128 5.12151L16.958 3.29151C17.1449 3.10426 17.3985 2.99902 17.663 2.99902C17.9276 2.99902 18.1812 3.10426 18.368 3.29151L20.708 5.63151ZM2.99805 20.5015V17.4615C2.99805 17.3215 3.04805 17.2015 3.14805 17.1015L14.058 6.19151L17.808 9.94151L6.88805 20.8515C6.79805 20.9515 6.66805 21.0015 6.53805 21.0015H3.49805C3.21805 21.0015 2.99805 20.7815 2.99805 20.5015Z" fill="#999999"/>
                                </svg>
                            </b-button>
                        </div>
                    </div>
                    <div class="content">
                        <ul>
                            <li v-for="t in template.data" @click="selectTemplate(t)" v-bind:class="{'active': template.selected && t.id === template.selected.id}">
                                <span>{{t.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right dataContent">
                    <div class="rightContent">
                        <gofix-table :settings="approvals.tableConfig"
                            :table-items="approvals.tableItems"
                            @load-items="getTableData"
                            @new-item="openCreateApproval"
                            @row-click="openEditApproval"
                            @delete-items="deleteItems"
                            @get-selected="saveSequence"
                            ref="gofixTable">
                            <template slot="gofix_table:finance_limit" slot-scope="row">
                                {{ row.item.finance_limit | formatMoney }}
                            </template>
                            <template slot="gofix_table:before-actions"  slot-scope="row">
                                <div class="sortSequence">
                                    <span class="up no-edit" @click="upSequence(row.item)"><img src="img/arrow-up.png" alt=""></span>
                                    <span class="down no-edit" @click="downSequence(row.item)"><img src="img/arrow-down.png" alt=""></span>
                                </div>
                            </template>
                        </gofix-table>
                    </div>
                </div>
            </div>
        </div>
        <!--Modals-->

        <!-- Create approval template -->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.createTemplate.title" hide-footer :centered="true" v-model="modals.createTemplate.open">
            <div v-bind:class="{'run-loading':modals.createTemplate.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col>
                            <gofix-form-input label="Name" v-model="modals.createTemplate.data.name" required></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="APPLY" @click="saveTemplate" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <!--Delete approval template-->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.deleteTemplate.open">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.deleteTemplate.open = false">No</b-button>
                <b-button class="custom-btn" @click="deleteTemplate" :disabled="modals.deleteTemplate.loading">
                    <b-spinner v-if="modals.deleteTemplate.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <!--Create approval-->
        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create" 
            :title="modals.createApproval.title"  
            hide-footer 
            :centered="true" 
            v-model="modals.createApproval.open">
            <div class="" v-bind:class="{'run-loading':modals.createApproval.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-dropdown
                                :multiple="true"
                                label="Roles"
                                vLabel="name"
                                :clearable="false"
                                v-model="modals.createApproval.data.roles"
                                :options="modals.createApproval.roles"
                                required />
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input-number
                                label="Financial Limit"
                                v-model="modals.createApproval.data.finance_limit"
                                prefix="$" 
                                required />
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="APPLY" @click="saveApproval" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'approval-template',
        data() {
            let filter = JSON.parse(JSON.stringify(filters['approval_route']));
            return {
                template:{
                    loading: false,
                    data: [],
                    selected: null
                },
                approvals:{
                    tableConfig:{
                        name: 'master-approval-template-route',
                        controls:{
                            sendSelected:true,
                            sendSelectedText:"SAVE SEQUENCE",
                            create: this.$checkRole(this.$accessModule.approval_template, 'create'),
                            delete: this.$checkRole(this.$accessModule.approval_template, 'delete'),
                        },
                        filter: filter,
                        page: 1,
                        limit: 100,
                        total: 0,
                        fields: [
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'checkbox-column text-right',
                                tdClass: 'checkbox-column text-right no-edit',
                                width: 50,
                                thStyle: "width:50px",
                            },
                            {
                                key: 'sequence',
                                label: 'Approval Level',
                                isActive: 1,
                                isFilter: true,
                                thStyle: "width:150px",
                                sorting: false,
                                with:150,
                                thClass: 'checkbox-column text-right',
                                tdClass: 'checkbox-column text-right',
                            },
                            {
                                key: 'finance_limit',
                                label: 'Finance Limit',
                                isActive: 1,
                                isFilter: true,
                                thStyle: "width:150px",
                                sorting: false,
                                with:150,
                                thClass: 'checkbox-column text-right',
                                tdClass: 'checkbox-column text-right',
                            },
                            {
                                key: 'role_name',
                                label: 'Roles',
                                isActive: 1,
                                isFilter: true,
                                thStyle: "width:auto",
                                sorting: false,
                                with:null,
                            }
                        ],
                        sortColumn: "sequence",
                        sortDirection: "asc",
                    },
                    tableItems: [],
                },
                modals:{
                    createTemplate:{
                        title: "Create Master Approval Route",
                        open:false,
                        loading:false,
                        data:{
                            name:null,
                            id:null,
                            property_id:null,
                            approval_process_id:null,
                            contract_id:null,
                            effective_date:null
                        }
                    },
                    deleteTemplate:{
                        open:false,
                        loading:false,
                    },
                    createApproval:{
                        title: "Add approval",
                        open: false,
                        loading: false,
                        data: {
                            id: null,
                            roles: null,
                            finance_limit: null,
                            approval_template_id: null,

                        },
                        roles:[]
                    }
                }
            }
        },
        created() {
            this.getApprovalTemplate();
            this.getFmRoles();
        },
        watch: {
            "template.selected" : function(val){
                if(val){
                    this.$refs.gofixTable.reloadTableItems();
                }
            }
        },
        methods: {
            /*- Approval Template ----*/
            getApprovalTemplate(){
                this.template.loading = true;
                let requestData = {
                    limit: -1,
                    page: 1,
                    filter: {
                        name_not_null : true
                    }
                };
                this.$store.dispatch("ApprovalTemplateController/getItems", requestData)
                    .then(response => {
                        this.template.loading = false;
                        this.template.data = response.items;
                        if(!this.template.selected){
                            if(this.template.data.length){
                                this.template.selected = this.template.data[0];
                            }
                        }
                    })
                    .catch(err => {
                        this.template.loading = false;
                    });
            },
            selectTemplate(template){
                this.template.selected = template
            },
            saveTemplate(){
                if(!this.modals.createTemplate.data.name){
                    return this.$alertNotification("Please enter the Name", "danger");
                }
                if(this.modals.createTemplate.loading) return;
                this.modals.createTemplate.loading = true;
                if(!this.modals.createTemplate.data.id){
                    this.$store.dispatch("ApprovalTemplateController/saveItem", this.modals.createTemplate.data)
                        .then(response => {
                            this.getApprovalTemplate();
                            this.modals.createTemplate.loading = false;
                            this.modals.createTemplate.open = false;
                            this.template.selected = response
                            this.$alertNotification(this.$notificationV2('adding', 'approval_template_master'));
                        })
                        .catch(err => {
                            this.modals.createTemplate.loading = false;
                        });
                }else{
                    this.$store.dispatch("ApprovalTemplateController/updateItem", this.modals.createTemplate.data)
                        .then(response => {
                            this.getApprovalTemplate();
                            this.modals.createTemplate.loading = false;
                            this.modals.createTemplate.open = false;
                            this.template.selected = response
                            this.$alertNotification(this.$notificationV2('editing', 'approval_template_master'));
                        })
                        .catch(err => {
                            this.modals.createTemplate.loading = false;
                        });
                }
            },
            deleteTemplate(){
                let ids = [this.template.selected.id];
                this.$store.dispatch("ApprovalTemplateController/deleteItems", ids)
                    .then(response => {
                        this.template.selected = null;
                        this.getApprovalTemplate();
                        this.modals.deleteTemplate.loading = false;
                        this.modals.deleteTemplate.open = false;
                        this.$alertNotification(this.$notificationV2('deleting', 'approval_template_master'));
                    })
                    .catch(err => {
                        this.modals.deleteTemplate.loading = false;
                    });
            },
            openCreatetemplate(){
                this.modals.createTemplate.title = "Create Master Approval Route";
                this.modals.createTemplate.data.id = null;
                this.modals.createTemplate.data.name = null;
                this.modals.createTemplate.open = true;
            },
            openUpdatetemplate(){
                if(!this.template.selected){
                    return this.$alertNotification("Please select a template", "danger");
                }
                this.modals.createTemplate.title = "Edit Master Approval Route";
                this.modals.createTemplate.data.id = this.template.selected.id;
                this.modals.createTemplate.data.name = this.template.selected.name;
                this.modals.createTemplate.open = true;
            },

            /*- Approvals ----*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if(!this.template.selected || !this.template.selected.id){
                    this.approvals.tableItems = [];
                    this.approvals.tableConfig.total = 0;
                    resolve({
                        items: [],
                        total: 0
                    });
                    return;
                }
                tableRequest.filter.approval_template_id.value = this.template.selected  ? this.template.selected.id:null;
                await this.$store.dispatch("ApprovalController/getApprovalItems", tableRequest)
                    .then(response => {
                        this.approvals.tableItems = response.items;
                        this.approvals.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the checklist", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('ApprovalController/deleteApproval', {
                    ids:ids,
                    approval_template_id : this.template.selected.id
                })
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'approval_template_master_item'));
                    })
                    .catch(err => {
                        reject();
                    })
            },
            saveApproval() {
                let approvalObject = Object.assign({}, this.modals.createApproval.data);
                if (!approvalObject.finance_limit) {
                    approvalObject.finance_limit = 0;
                }else{
                   approvalObject.finance_limit = this.$accounting.unformat(approvalObject.finance_limit)
                }
                if (!approvalObject.roles) {
                    return this.$alertNotification("Role is a required field.", "danger");
                }
                
                approvalObject.roles = approvalObject.roles.map(item => item.id);
                if(this.modals.createApproval.loading) return;
                this.modals.createApproval.loading = true;
                if(!approvalObject.id) {
                    this.$store.dispatch('ApprovalController/createApproval', approvalObject)
                        .then(result => {
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.modals.createApproval.loading = false;
                            this.modals.createApproval.open = false;
                            this.$alertNotification(this.$notificationV2('editing', 'approval_template_master_item'));
                        })
                        .catch(err => {
                            this.$alertNotification("Sorry, Approval can't create now. Please try again later", "danger");
                            this.modals.createApproval.loading = true;
                        })
                }else{
                    this.$store.dispatch('ApprovalController/updateApproval', approvalObject)
                        .then(result => {
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.modals.createApproval.loading = false;
                            this.modals.createApproval.open = false;
                            this.$alertNotification(this.$notificationV2('editing', 'approval_template_master_item'));
                        })
                        .catch(err => {
                            this.$alertNotification("Sorry, Approval can't update now. Please try again later", "danger");
                            this.modals.createApproval.loading = true;
                        })
                }
            },
            openCreateApproval(){
                if(!this.template.selected ){
                    return this.$alertNotification("Please select a approval template.", "danger");
                }
                this.modals.createApproval.title = "Add approval";
                this.modals.createApproval.data = {
                    id : null,
                    roles: null,
                    finance_limit: null,
                    approval_template_id: this.template.selected.id
                };
                this.modals.createApproval.open = true;
            },
            openEditApproval(item){

                if ( this.$checkRole(this.$accessModule.approval_template, 'update')  == false) {
                    return;
                }

                this.modals.createApproval.title = "Edit approval";
                this.modals.createApproval.data = {
                    id : item.id,
                    roles: item.roles,
                    finance_limit: this.$accounting.formatMoney(item.finance_limit),
                    approval_template_id: item.approval_template_id
                };
                this.modals.createApproval.open = true;
            },
            upSequence(item){
                let arr = JSON.parse(JSON.stringify(this.approvals.tableItems));
                let order_number = item.sequence
                let prev_item = arr[order_number - 2]
                if((prev_item && prev_item.finance_limit) !== item.finance_limit){
                    return
                }
                prev_item.sequence = order_number;
                arr[order_number - 1] = prev_item;
                item.sequence = order_number - 1
                arr[order_number - 2] = item;
                this.approvals.tableItems = JSON.parse(JSON.stringify(arr));
            },
            downSequence(item){
                let arr = JSON.parse(JSON.stringify(this.approvals.tableItems));
                let order_number = item.sequence
                let next_item = arr[order_number]
                if((next_item && next_item.finance_limit) !== item.finance_limit){
                    return
                }
                next_item.sequence = order_number;
                arr[order_number - 1] = next_item;
                item.sequence = order_number + 1
                arr[order_number] = item;
                this.approvals.tableItems = JSON.parse(JSON.stringify(arr));
            },
            saveSequence(){
                let params = this.approvals.tableItems.map((x, index) => {
                    return {id: x.id, level: index + 1}
                });
                this.$store.dispatch("ApprovalController/saveSequence", {sequence: JSON.stringify(params)})
                    .then(response => {
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification("Success");
                    });
            },

            /*- Global data ----*/
            getFmRoles(){
                this.$store.dispatch("RoleController/getRoleItems",{
                    filter:{
                        group_tags: "FM"
                    }
                })
                    .then(response => {
                        this.modals.createApproval.roles = response.items;
                    });
            }
        }
    }
</script>
